<div class="container-fluid tp-box" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="card">
			<div class="card-header card-header-warning card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false, '')">
					<i class="material-icons">account_balance_wallet</i>
				</div>
				<h3 class="card-title">Ready To Pay {{ title }}</h3>
			</div>
			<div class="card-body" *ngIf="viewing">
				<div class="text-right mb-2">
					<button class="btn btn-sm btn-success" (click)="exportXls()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-excel-o"></i> XLS
					</button>
					<button class="btn btn-sm btn-danger ml-2" (click)="exportPdf()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-pdf-o"></i> PDF
					</button>
				</div>
				<div class="table" #print_table>
					<table class="table">
						<tr>
							<th>Vendor ID</th>
							<th>Vendor Name</th>
							<th>Type</th>
							<th>Trans #</th>
							<th>Reference</th>
							<th>Date</th>
							<th>Due Date</th>
							<th>Amount</th>
							<th>Balance</th>
							<th>Actions</th>
						</tr>
						<tr *ngFor="let v of viewing">
							<td>{{ v.supplierid }}</td>
							<td>{{ v.suppname }}</td>
							<td>{{ v.typename }}</td>
							<td>{{ v.transno }}</td>
							<td>{{ v.suppreference }}</td>
							<td>{{ v.trandate }}</td>
							<td>{{ v.duedate }}</td>
							<td>{{ getAmount(v) | currency }}</td>
							<td>{{ getBalance(v) | currency }}</td>
							<td>
								<button mat-icon-button (click)="navigateToVendor(v.supplierid)" matTooltip="View Vendor" *ngIf="v.supplierid">
									<mat-icon>visibility</mat-icon>
								</button>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-warning card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(readyToPay, 'All')">
					<i class="material-icons">account_balance_wallet</i>
				</div>
				<p class="card-category">Ready To Pay</p>
				<h3 class="card-title">
					<span *ngIf="readyToPay">
						{{ readyToPay.length }}
					</span>
					<span *ngIf="!readyToPay">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
				</h3>
			</div>
			<div class="card-footer">
				<div class="stats pointer">
					<a (click)="toggleFlip(readyToPay, 'All')">
						<i class="material-icons">content_copy</i>
						View Now</a>
				</div>
			</div>
		</div>
	</div>
</div>
